import { SiteService } from '@/services';

export default {
	namespaced: true,
	state: {
		chainSiteIds: []
	},
	mutations: {
		setSiteIds(state, value) {
			state.chainSiteIds = value
		}
	},
	actions: {
		async GetSiteIdsByChainId({ commit }, chainId) {
			var siteIds = await SiteService.GetSiteIdsByChainId(chainId);
			commit('setSiteIds', siteIds)
		},
	},
	getters: {
		getChainSiteIds: state => state.chainSiteIds
	}
};
